<template>
	<div class="page">
		<Tip :tip="tip" />
		<div class="screen_div">
			<el-date-picker class="picker" v-model="screen.created_time" type="datetimerange"
				value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
				placeholder="请选择时间范围" />
			<el-select class="select" v-model="screen.supplier_id" clearable placeholder="供应商名称">
				<el-option v-for="item in supplierList" :key="item.supplier_id" :label="item.supplier_name" :value="item.supplier_id" />
			</el-select>
            <el-input class="input" v-model="screen.settlement_no" style="width: 250px;margin-left: 10px;" placeholder="结算单号" clearable />
			<el-select class="select" v-model="screen.state" clearable placeholder="状态">
				<el-option v-for="item in stateList" :key="item.value" :label="item.label" :value="item.value" />
			</el-select>
			<el-button class="screen_btn" @click="getSupplierList(1)">筛选</el-button>
		</div>
		<div class="from_div">
			<el-table class="table_div" :data="tableData" v-loading="loading" :header-cell-style="tabStyle">
				<el-table-column label="编号" type="index" width="80" align="center">
				</el-table-column>
				<el-table-column label="结算单">
					<template slot-scope="scope">
						<div class="col">
							<span>单号：{{scope.row.settlement_no}}</span>
							<span>结算：{{scope.row.supplier_company}}</span>
							<span>制单：{{scope.row.created_time}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="商品" width="100" align="center">
					<template slot-scope="scope">
						<span>{{scope.row.good_quatity}}</span>
					</template>
				</el-table-column>
				<el-table-column label="结算金额"  width="150" align="center">
					<template slot-scope="scope">
						<span>{{scope.row.settlement_amount}}</span>
					</template>
				</el-table-column>
				<el-table-column label="结算时间" align="center">
					<template slot-scope="scope">
						<span>{{scope.row.settlement_time}}</span>
					</template>
				</el-table-column>
				<el-table-column label="状态" width="150" align="center">
					<template slot-scope="scope">
						<span>{{scope.row.state_text}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="150" align="center">
					<template slot-scope="scope">
						<el-button class="item_btn" size="mini" type="primary" v-if="scope.row.state == 1"
							@click="open(scope.row.settlement_id)">付款</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!--弹出层-->
		<Popup :name="name" :show="show" @close='close' :type="settlement_id"/>
		<div class="foot_div">
			<!--分页按钮-->
			<el-pagination class="pagination" background layout="prev, pager, next,jumper, ->, total" :total="total"
				@current-change="handleCurrentChange" :currentPage="screen.page" :pageSize="screen.limit">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import Popup from "../../../components/Popup/Popup.vue"
	import {supplier, supplierSelect} from "../../../request/apis.js"
	export default {
		components: {
			Tip,
			Popup
		},
		data() {
			return {
				tip: '供应商已经发起结算的单据列表。',
				supplierList: [], //供应商列表
				settlementList: [], //结算单号列表
				stateList: [{
					value: '1',
					label: '待结算'
				}, {
					value: '2',
					label: '已结算'
				}, {
					value: '3',
					label: '已结算已到款'
				}], //状态列表
				settlement_id:-1,//供应商结算id
				screen: {
					created_time: [], //创建时间范围
					supplier_id: '', //供应商id，登录信息中的supplier_id
					settlement_no: '', //结算单号
					state: '', //状态1=待结算,2=已结算,3=已结算已到款
					page: 1, //当前页 刷新后默认显示第一页
					limit: 10, //每一页显示的数据量 此处每页显示10条数据
				},
                loading: false,
				tableData: [],
				total: 0, //总条数
				name: '',
                id: 0,
				show: false
			}
		},
		computed: {
			tabStyle() {
				return {
					background: '#f5f5f5',
					color: '#333'
				}
			}
		},
		mounted() {
			this.getSupplierList();
            this.getAllSupplier()
		},
		methods: {
			
			//获取供应商结算列表
			getSupplierList(){
				supplier({...this.screen},0).then(res=>{
					if(res.code == 0){
						this.total = res.count;
						this.tableData = res.data
					}else{
						this.$message.error(res.msg);
					}
				}).catch(err=>{})
			},

            getAllSupplier(){
                supplierSelect({...this.screen}).then(res=>{
					if(res.code == 0){
						this.supplierList = res.data
					}else{
						this.$message.error(res.msg);
					}
				}).catch(err=>{})
            },
			
			//点击按钮切换页面
			handleCurrentChange(page) {
				this.screen.page = page; //每次点击分页按钮，当前页发生变化
				this.getSupplierList();
			},

			open(id) {
				this.name = 'supplierSetAccountDetail';
                this.settlement_id = id;
				this.show = true
			},

			close(index) {
				this.show = false
				if (index == 1) {
                    this.getSupplierList();
					// this.name = 'paymentReceiptEdit';
					// this.show = true
				}
			}
		}
	}
</script>

<style scoped>
	
	.page {
		margin-bottom: 66px;
		padding: 20px 20px 0 20px;
		min-height: -webkit-fill-available;
	}
	
	.screen_div {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: auto;
		margin-top: 20px;
	}

	.col {
		display: flex;
		flex-direction: column;
		justify-content: left;
	}

	.select {
		width: 128px;
		margin-left: 13px;
	}

	.screen_btn {
		margin-left: 13px;
	}

	.el-button--mini {
		margin-right: 10px;
	}
	
	.item_btn {
		margin: 0 5px 0 0;
	}
	
	/*伪类样式*/
	.item_btn:nth-child(3) {
		margin-top: 5px;
	}
	
	.from_div {
		width: 100%;
		height: 610px;
		max-height: 100%;
		overflow: scroll;
		margin-top: 20px;
	}

	.table_div {
		width: 100%;
	}
	
	.foot_div {
		position: absolute;
		display: flex;
		flex-direction: row-reverse;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		margin-left: 66px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
		z-index: 9;
	}
	
	.pagination {
		display: flex;
		padding: 20px 30px 20px 30px
	}
	
	.el-dropdown-link {
		padding: 15px 5px;
		cursor: pointer;
		color: #fff;
	}
	
	.dropdown-menu {
		margin-bottom: 25px !important;
	}
</style>